export const GOOGLE_AUTH_FLOW = {
    LOGIN: 'login',
    REGISTER: 'register',
} as const;

export type GoogleAuthFlow = typeof GOOGLE_AUTH_FLOW[keyof typeof GOOGLE_AUTH_FLOW];

export const GOOGLE_AUTH_RESULT = {
    USER_NOT_REGISTERED: 'google-user-not-registered',
    EMAIL_ALREADY_EXISTS: 'google-email-already-exists',
    EXISTING_ACCOUNT_EMAIL_UNVERIFIED: 'google-existing-account-email-unverified',
} as const;

export const GOOGLE_AUTH_POPUP_MESSAGE = {
    SUCCESS: 'auth-success',
    REGISTRATION_REQUIRED: 'auth-registration-required',
    EMAIL_CONFLICT: 'auth-google-email-conflict',
    EXISTING_ACCOUNT_EMAIL_UNVERIFIED: 'auth-google-existing-account-email-unverified',
} as const;
